export const testGroupStageGames = {
  A: [
    {
      match_number: 1,
      match_datetime_utc: "2026-06-12T20:30:00.000+00:00",
      group: "A",
      location: "Various",
      game_status: "InProgress",
      winner: "NotFinal",
      team_1: {
        team_number: 1,
        country_name: "Mexico",
        flag_image_url: "https://flagpedia.net/data/flags/h80/mx.png",
        world_rank: 15,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 2,
        country_name: "South Africa",
        flag_image_url: "https://flagpedia.net/data/flags/h80/za.png",
        world_rank: 60,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 2,
      match_datetime_utc: "2026-06-12T20:30:00.000+00:00",
      group: "A",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 3,
        country_name: "South Korea",
        flag_image_url: "https://flagpedia.net/data/flags/h80/kr.png",
        world_rank: 25,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 4,
        country_name: "Czech Republic",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cz.png",
        world_rank: 41,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 3,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "A",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 1,
        country_name: "Mexico",
        flag_image_url: "https://flagpedia.net/data/flags/h80/mx.png",
        world_rank: 15,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 3,
        country_name: "South Korea",
        flag_image_url: "https://flagpedia.net/data/flags/h80/kr.png",
        world_rank: 25,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 4,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "A",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 2,
        country_name: "South Africa",
        flag_image_url: "https://flagpedia.net/data/flags/h80/za.png",
        world_rank: 60,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 4,
        country_name: "Czech Republic",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cz.png",
        world_rank: 41,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 5,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "A",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 1,
        country_name: "Mexico",
        flag_image_url: "https://flagpedia.net/data/flags/h80/mx.png",
        world_rank: 15,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 4,
        country_name: "Czech Republic",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cz.png",
        world_rank: 41,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 6,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "A",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 2,
        country_name: "South Africa",
        flag_image_url: "https://flagpedia.net/data/flags/h80/za.png",
        world_rank: 60,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 3,
        country_name: "South Korea",
        flag_image_url: "https://flagpedia.net/data/flags/h80/kr.png",
        world_rank: 25,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  B: [
    {
      match_number: 7,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "B",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 5,
        country_name: "Canada",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ca.png",
        world_rank: 30,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 6,
        country_name: "Bosnia & Herz.",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ba.png",
        world_rank: 65,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 8,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "B",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 7,
        country_name: "Qatar",
        flag_image_url: "https://flagpedia.net/data/flags/h80/qa.png",
        world_rank: 55,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 8,
        country_name: "Switzerland",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ch.png",
        world_rank: 19,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 9,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "B",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 5,
        country_name: "Canada",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ca.png",
        world_rank: 30,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 7,
        country_name: "Qatar",
        flag_image_url: "https://flagpedia.net/data/flags/h80/qa.png",
        world_rank: 55,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 10,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "B",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 6,
        country_name: "Bosnia & Herz.",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ba.png",
        world_rank: 65,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 8,
        country_name: "Switzerland",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ch.png",
        world_rank: 19,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 11,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "B",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 5,
        country_name: "Canada",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ca.png",
        world_rank: 30,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 8,
        country_name: "Switzerland",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ch.png",
        world_rank: 19,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 12,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "B",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 6,
        country_name: "Bosnia & Herz.",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ba.png",
        world_rank: 65,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 7,
        country_name: "Qatar",
        flag_image_url: "https://flagpedia.net/data/flags/h80/qa.png",
        world_rank: 55,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  C: [
    {
      match_number: 13,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "C",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 9,
        country_name: "Brazil",
        flag_image_url: "https://flagpedia.net/data/flags/h80/br.png",
        world_rank: 6,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 10,
        country_name: "Morocco",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ma.png",
        world_rank: 8,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 14,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "C",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 11,
        country_name: "Haiti",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ht.png",
        world_rank: 83,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 12,
        country_name: "Scotland",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gb-sct.png",
        world_rank: 43,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 15,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "C",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 9,
        country_name: "Brazil",
        flag_image_url: "https://flagpedia.net/data/flags/h80/br.png",
        world_rank: 6,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 11,
        country_name: "Haiti",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ht.png",
        world_rank: 83,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 16,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "C",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 10,
        country_name: "Morocco",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ma.png",
        world_rank: 8,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 12,
        country_name: "Scotland",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gb-sct.png",
        world_rank: 43,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 17,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "C",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 9,
        country_name: "Brazil",
        flag_image_url: "https://flagpedia.net/data/flags/h80/br.png",
        world_rank: 6,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 12,
        country_name: "Scotland",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gb-sct.png",
        world_rank: 43,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 18,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "C",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 10,
        country_name: "Morocco",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ma.png",
        world_rank: 8,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 11,
        country_name: "Haiti",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ht.png",
        world_rank: 83,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  D: [
    {
      match_number: 19,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "D",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 13,
        country_name: "USA",
        flag_image_url: "https://flagpedia.net/data/flags/h80/us.png",
        world_rank: 16,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 14,
        country_name: "Paraguay",
        flag_image_url: "https://flagpedia.net/data/flags/h80/py.png",
        world_rank: 40,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 20,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "D",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 15,
        country_name: "Australia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/au.png",
        world_rank: 27,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 16,
        country_name: "Türkiye",
        flag_image_url: "https://flagpedia.net/data/flags/h80/tr.png",
        world_rank: 22,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 21,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "D",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 13,
        country_name: "USA",
        flag_image_url: "https://flagpedia.net/data/flags/h80/us.png",
        world_rank: 16,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 15,
        country_name: "Australia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/au.png",
        world_rank: 27,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 22,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "D",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 14,
        country_name: "Paraguay",
        flag_image_url: "https://flagpedia.net/data/flags/h80/py.png",
        world_rank: 40,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 16,
        country_name: "Türkiye",
        flag_image_url: "https://flagpedia.net/data/flags/h80/tr.png",
        world_rank: 22,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 23,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "D",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 13,
        country_name: "USA",
        flag_image_url: "https://flagpedia.net/data/flags/h80/us.png",
        world_rank: 16,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 16,
        country_name: "Türkiye",
        flag_image_url: "https://flagpedia.net/data/flags/h80/tr.png",
        world_rank: 22,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 24,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "D",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 14,
        country_name: "Paraguay",
        flag_image_url: "https://flagpedia.net/data/flags/h80/py.png",
        world_rank: 40,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 15,
        country_name: "Australia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/au.png",
        world_rank: 27,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  E: [
    {
      match_number: 25,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "E",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 17,
        country_name: "Germany",
        flag_image_url: "https://flagpedia.net/data/flags/h80/de.png",
        world_rank: 10,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 18,
        country_name: "Curaçao",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cw.png",
        world_rank: 82,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 26,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "E",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 19,
        country_name: "Ivory Coast",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ci.png",
        world_rank: 34,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 20,
        country_name: "Ecuador",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ec.png",
        world_rank: 23,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 27,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "E",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 17,
        country_name: "Germany",
        flag_image_url: "https://flagpedia.net/data/flags/h80/de.png",
        world_rank: 10,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 19,
        country_name: "Ivory Coast",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ci.png",
        world_rank: 34,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 28,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "E",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 18,
        country_name: "Curaçao",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cw.png",
        world_rank: 82,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 20,
        country_name: "Ecuador",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ec.png",
        world_rank: 23,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 29,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "E",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 17,
        country_name: "Germany",
        flag_image_url: "https://flagpedia.net/data/flags/h80/de.png",
        world_rank: 10,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 20,
        country_name: "Ecuador",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ec.png",
        world_rank: 23,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 30,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "E",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 18,
        country_name: "Curaçao",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cw.png",
        world_rank: 82,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 19,
        country_name: "Ivory Coast",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ci.png",
        world_rank: 34,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  F: [
    {
      match_number: 31,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "F",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 21,
        country_name: "Netherlands",
        flag_image_url: "https://flagpedia.net/data/flags/h80/nl.png",
        world_rank: 7,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 22,
        country_name: "Japan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/jp.png",
        world_rank: 18,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 32,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "F",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 23,
        country_name: "Sweden",
        flag_image_url: "https://flagpedia.net/data/flags/h80/se.png",
        world_rank: 38,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 24,
        country_name: "Tunisia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/tn.png",
        world_rank: 44,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 33,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "F",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 21,
        country_name: "Netherlands",
        flag_image_url: "https://flagpedia.net/data/flags/h80/nl.png",
        world_rank: 7,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 23,
        country_name: "Sweden",
        flag_image_url: "https://flagpedia.net/data/flags/h80/se.png",
        world_rank: 38,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 34,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "F",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 22,
        country_name: "Japan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/jp.png",
        world_rank: 18,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 24,
        country_name: "Tunisia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/tn.png",
        world_rank: 44,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 35,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "F",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 21,
        country_name: "Netherlands",
        flag_image_url: "https://flagpedia.net/data/flags/h80/nl.png",
        world_rank: 7,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 24,
        country_name: "Tunisia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/tn.png",
        world_rank: 44,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 36,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "F",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 22,
        country_name: "Japan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/jp.png",
        world_rank: 18,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 23,
        country_name: "Sweden",
        flag_image_url: "https://flagpedia.net/data/flags/h80/se.png",
        world_rank: 38,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  G: [
    {
      match_number: 37,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "G",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 25,
        country_name: "Belgium",
        flag_image_url: "https://flagpedia.net/data/flags/h80/be.png",
        world_rank: 9,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 26,
        country_name: "Egypt",
        flag_image_url: "https://flagpedia.net/data/flags/h80/eg.png",
        world_rank: 29,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 38,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "G",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 27,
        country_name: "Iran",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ir.png",
        world_rank: 21,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 28,
        country_name: "New Zealand",
        flag_image_url: "https://flagpedia.net/data/flags/h80/nz.png",
        world_rank: 85,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 39,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "G",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 25,
        country_name: "Belgium",
        flag_image_url: "https://flagpedia.net/data/flags/h80/be.png",
        world_rank: 9,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 27,
        country_name: "Iran",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ir.png",
        world_rank: 21,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 40,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "G",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 26,
        country_name: "Egypt",
        flag_image_url: "https://flagpedia.net/data/flags/h80/eg.png",
        world_rank: 29,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 28,
        country_name: "New Zealand",
        flag_image_url: "https://flagpedia.net/data/flags/h80/nz.png",
        world_rank: 85,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 41,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "G",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 25,
        country_name: "Belgium",
        flag_image_url: "https://flagpedia.net/data/flags/h80/be.png",
        world_rank: 9,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 28,
        country_name: "New Zealand",
        flag_image_url: "https://flagpedia.net/data/flags/h80/nz.png",
        world_rank: 85,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 42,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "G",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 26,
        country_name: "Egypt",
        flag_image_url: "https://flagpedia.net/data/flags/h80/eg.png",
        world_rank: 29,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 27,
        country_name: "Iran",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ir.png",
        world_rank: 21,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  H: [
    {
      match_number: 43,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "H",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 29,
        country_name: "Spain",
        flag_image_url: "https://flagpedia.net/data/flags/h80/es.png",
        world_rank: 2,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 30,
        country_name: "Cape Verde",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cv.png",
        world_rank: 69,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 44,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "H",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 31,
        country_name: "Saudi Arabia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/sa.png",
        world_rank: 61,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 32,
        country_name: "Uruguay",
        flag_image_url: "https://flagpedia.net/data/flags/h80/uy.png",
        world_rank: 17,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 45,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "H",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 29,
        country_name: "Spain",
        flag_image_url: "https://flagpedia.net/data/flags/h80/es.png",
        world_rank: 2,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 31,
        country_name: "Saudi Arabia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/sa.png",
        world_rank: 61,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 46,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "H",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 30,
        country_name: "Cape Verde",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cv.png",
        world_rank: 69,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 32,
        country_name: "Uruguay",
        flag_image_url: "https://flagpedia.net/data/flags/h80/uy.png",
        world_rank: 17,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 47,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "H",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 29,
        country_name: "Spain",
        flag_image_url: "https://flagpedia.net/data/flags/h80/es.png",
        world_rank: 2,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 32,
        country_name: "Uruguay",
        flag_image_url: "https://flagpedia.net/data/flags/h80/uy.png",
        world_rank: 17,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 48,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "H",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 30,
        country_name: "Cape Verde",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cv.png",
        world_rank: 69,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 31,
        country_name: "Saudi Arabia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/sa.png",
        world_rank: 61,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  I: [
    {
      match_number: 49,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "I",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 33,
        country_name: "France",
        flag_image_url: "https://flagpedia.net/data/flags/h80/fr.png",
        world_rank: 1,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 34,
        country_name: "Senegal",
        flag_image_url: "https://flagpedia.net/data/flags/h80/sn.png",
        world_rank: 14,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 50,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "I",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 35,
        country_name: "Iraq",
        flag_image_url: "https://flagpedia.net/data/flags/h80/iq.png",
        world_rank: 57,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 36,
        country_name: "Norway",
        flag_image_url: "https://flagpedia.net/data/flags/h80/no.png",
        world_rank: 31,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 51,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "I",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 33,
        country_name: "France",
        flag_image_url: "https://flagpedia.net/data/flags/h80/fr.png",
        world_rank: 1,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 35,
        country_name: "Iraq",
        flag_image_url: "https://flagpedia.net/data/flags/h80/iq.png",
        world_rank: 57,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 52,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "I",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 34,
        country_name: "Senegal",
        flag_image_url: "https://flagpedia.net/data/flags/h80/sn.png",
        world_rank: 14,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 36,
        country_name: "Norway",
        flag_image_url: "https://flagpedia.net/data/flags/h80/no.png",
        world_rank: 31,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 53,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "I",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 33,
        country_name: "France",
        flag_image_url: "https://flagpedia.net/data/flags/h80/fr.png",
        world_rank: 1,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 36,
        country_name: "Norway",
        flag_image_url: "https://flagpedia.net/data/flags/h80/no.png",
        world_rank: 31,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 54,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "I",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 34,
        country_name: "Senegal",
        flag_image_url: "https://flagpedia.net/data/flags/h80/sn.png",
        world_rank: 14,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 35,
        country_name: "Iraq",
        flag_image_url: "https://flagpedia.net/data/flags/h80/iq.png",
        world_rank: 57,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  J: [
    {
      match_number: 55,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "J",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 37,
        country_name: "Argentina",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ar.png",
        world_rank: 3,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 38,
        country_name: "Algeria",
        flag_image_url: "https://flagpedia.net/data/flags/h80/dz.png",
        world_rank: 28,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 56,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "J",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 39,
        country_name: "Austria",
        flag_image_url: "https://flagpedia.net/data/flags/h80/at.png",
        world_rank: 24,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 40,
        country_name: "Jordan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/jo.png",
        world_rank: 63,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 57,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "J",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 37,
        country_name: "Argentina",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ar.png",
        world_rank: 3,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 39,
        country_name: "Austria",
        flag_image_url: "https://flagpedia.net/data/flags/h80/at.png",
        world_rank: 24,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 58,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "J",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 38,
        country_name: "Algeria",
        flag_image_url: "https://flagpedia.net/data/flags/h80/dz.png",
        world_rank: 28,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 40,
        country_name: "Jordan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/jo.png",
        world_rank: 63,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 59,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "J",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 37,
        country_name: "Argentina",
        flag_image_url: "https://flagpedia.net/data/flags/h80/ar.png",
        world_rank: 3,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 40,
        country_name: "Jordan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/jo.png",
        world_rank: 63,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 60,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "J",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 38,
        country_name: "Algeria",
        flag_image_url: "https://flagpedia.net/data/flags/h80/dz.png",
        world_rank: 28,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 39,
        country_name: "Austria",
        flag_image_url: "https://flagpedia.net/data/flags/h80/at.png",
        world_rank: 24,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  K: [
    {
      match_number: 61,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "K",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 41,
        country_name: "Portugal",
        flag_image_url: "https://flagpedia.net/data/flags/h80/pt.png",
        world_rank: 5,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 42,
        country_name: "DR Congo",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cd.png",
        world_rank: 46,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 62,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "K",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 43,
        country_name: "Uzbekistan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/uz.png",
        world_rank: 50,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 44,
        country_name: "Colombia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/co.png",
        world_rank: 13,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 63,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "K",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 41,
        country_name: "Portugal",
        flag_image_url: "https://flagpedia.net/data/flags/h80/pt.png",
        world_rank: 5,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 43,
        country_name: "Uzbekistan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/uz.png",
        world_rank: 50,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 64,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "K",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 42,
        country_name: "DR Congo",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cd.png",
        world_rank: 46,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 44,
        country_name: "Colombia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/co.png",
        world_rank: 13,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 65,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "K",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 41,
        country_name: "Portugal",
        flag_image_url: "https://flagpedia.net/data/flags/h80/pt.png",
        world_rank: 5,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 44,
        country_name: "Colombia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/co.png",
        world_rank: 13,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 66,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "K",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 42,
        country_name: "DR Congo",
        flag_image_url: "https://flagpedia.net/data/flags/h80/cd.png",
        world_rank: 46,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 43,
        country_name: "Uzbekistan",
        flag_image_url: "https://flagpedia.net/data/flags/h80/uz.png",
        world_rank: 50,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
  L: [
    {
      match_number: 67,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "L",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 45,
        country_name: "England",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gb-eng.png",
        world_rank: 4,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 46,
        country_name: "Croatia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/hr.png",
        world_rank: 11,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 68,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "L",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 47,
        country_name: "Ghana",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gh.png",
        world_rank: 74,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 48,
        country_name: "Panama",
        flag_image_url: "https://flagpedia.net/data/flags/h80/pa.png",
        world_rank: 33,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 69,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "L",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 45,
        country_name: "England",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gb-eng.png",
        world_rank: 4,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 47,
        country_name: "Ghana",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gh.png",
        world_rank: 74,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 70,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "L",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 46,
        country_name: "Croatia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/hr.png",
        world_rank: 11,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 48,
        country_name: "Panama",
        flag_image_url: "https://flagpedia.net/data/flags/h80/pa.png",
        world_rank: 33,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 71,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "L",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 45,
        country_name: "England",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gb-eng.png",
        world_rank: 4,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 48,
        country_name: "Panama",
        flag_image_url: "https://flagpedia.net/data/flags/h80/pa.png",
        world_rank: 33,
        goals: 0,
        points_earned: 0,
      },
    },
    {
      match_number: 72,
      match_datetime_utc: "2026-06-11T20:30:00.000+00:00",
      group: "L",
      location: "Various",
      game_status: "Scheduled",
      winner: "NotFinal",
      team_1: {
        team_number: 46,
        country_name: "Croatia",
        flag_image_url: "https://flagpedia.net/data/flags/h80/hr.png",
        world_rank: 11,
        goals: 0,
        points_earned: 0,
      },
      team_2: {
        team_number: 47,
        country_name: "Ghana",
        flag_image_url: "https://flagpedia.net/data/flags/h80/gh.png",
        world_rank: 74,
        goals: 0,
        points_earned: 0,
      },
    },
  ],
};

export const testContestStatus = {
  play_starts_at: "2026-06-11T00:00:00Z",
  current_stage: "group",
};

export const testlodash = {
  A: [
    {
      id: "group-a-mexico",
      name: "Mexico",
      teamNumber: 1,
      imageUrl: "https://flagpedia.net/data/flags/h80/mx.png",
      worldRank: 15,
      group: "A",
      groupPosition: 1,
      flaggedForEdit: false,
    },
    {
      id: "group-a-south-africa",
      name: "South Africa",
      teamNumber: 2,
      imageUrl: "https://flagpedia.net/data/flags/h80/za.png",
      worldRank: 60,
      group: "A",
      groupPosition: 2,
      flaggedForEdit: false,
    },
    {
      id: "group-a-south-korea",
      name: "South Korea",
      teamNumber: 3,
      imageUrl: "https://flagpedia.net/data/flags/h80/kr.png",
      worldRank: 25,
      group: "A",
      groupPosition: 3,
      flaggedForEdit: false,
    },
    {
      id: "group-a-czech-republic",
      name: "Czech Republic",
      teamNumber: 4,
      imageUrl: "https://flagpedia.net/data/flags/h80/cz.png",
      worldRank: 41,
      group: "A",
      groupPosition: 4,
      flaggedForEdit: false,
    },
  ],
  B: [
    {
      id: "group-b-switzerland",
      name: "Switzerland",
      teamNumber: 8,
      imageUrl: "https://flagpedia.net/data/flags/h80/ch.png",
      worldRank: 19,
      group: "B",
      groupPosition: 5,
      flaggedForEdit: false,
    },
    {
      id: "group-b-qatar",
      name: "Qatar",
      teamNumber: 7,
      imageUrl: "https://flagpedia.net/data/flags/h80/qa.png",
      worldRank: 55,
      group: "B",
      groupPosition: 7,
      flaggedForEdit: false,
    },
    {
      id: "group-b-canada",
      name: "Canada",
      teamNumber: 5,
      imageUrl: "https://flagpedia.net/data/flags/h80/ca.png",
      worldRank: 30,
      group: "B",
      groupPosition: 6,
      flaggedForEdit: false,
    },
    {
      id: "group-b-bosnia-herz",
      name: "Bosnia & Herz.",
      teamNumber: 6,
      imageUrl: "https://flagpedia.net/data/flags/h80/ba.png",
      worldRank: 65,
      group: "B",
      groupPosition: 8,
      flaggedForEdit: false,
    },
  ],
  C: [
    {
      id: "group-c-scotland",
      name: "Scotland",
      teamNumber: 12,
      imageUrl: "https://flagpedia.net/data/flags/h80/gb-sct.png",
      worldRank: 43,
      group: "C",
      groupPosition: 9,
      flaggedForEdit: false,
    },
    {
      id: "group-c-brazil",
      name: "Brazil",
      teamNumber: 9,
      imageUrl: "https://flagpedia.net/data/flags/h80/br.png",
      worldRank: 6,
      group: "C",
      groupPosition: 10,
      flaggedForEdit: false,
    },
    {
      id: "group-c-haiti",
      name: "Haiti",
      teamNumber: 11,
      imageUrl: "https://flagpedia.net/data/flags/h80/ht.png",
      worldRank: 83,
      group: "C",
      groupPosition: 11,
      flaggedForEdit: false,
    },
    {
      id: "group-c-morocco",
      name: "Morocco",
      teamNumber: 10,
      imageUrl: "https://flagpedia.net/data/flags/h80/ma.png",
      worldRank: 8,
      group: "C",
      groupPosition: 12,
      flaggedForEdit: false,
    },
  ],
  D: [
    {
      id: "group-d-australia",
      name: "Australia",
      teamNumber: 15,
      imageUrl: "https://flagpedia.net/data/flags/h80/au.png",
      worldRank: 27,
      group: "D",
      groupPosition: 13,
      flaggedForEdit: false,
    },
    {
      id: "group-d-turkiye",
      name: "Türkiye",
      teamNumber: 16,
      imageUrl: "https://flagpedia.net/data/flags/h80/tr.png",
      worldRank: 22,
      group: "D",
      groupPosition: 14,
      flaggedForEdit: false,
    },
    {
      id: "group-d-paraguay",
      name: "Paraguay",
      teamNumber: 14,
      imageUrl: "https://flagpedia.net/data/flags/h80/py.png",
      worldRank: 40,
      group: "D",
      groupPosition: 15,
      flaggedForEdit: false,
    },
    {
      id: "group-d-usa",
      name: "USA",
      teamNumber: 13,
      imageUrl: "https://flagpedia.net/data/flags/h80/us.png",
      worldRank: 16,
      group: "D",
      groupPosition: 16,
      flaggedForEdit: false,
    },
  ],
  E: [
    {
      id: "group-e-ivory-coast",
      name: "Ivory Coast",
      teamNumber: 19,
      imageUrl: "https://flagpedia.net/data/flags/h80/ci.png",
      worldRank: 34,
      group: "E",
      groupPosition: 17,
      flaggedForEdit: false,
    },
    {
      id: "group-e-ecuador",
      name: "Ecuador",
      teamNumber: 20,
      imageUrl: "https://flagpedia.net/data/flags/h80/ec.png",
      worldRank: 23,
      group: "E",
      groupPosition: 18,
      flaggedForEdit: false,
    },
    {
      id: "group-e-germany",
      name: "Germany",
      teamNumber: 17,
      imageUrl: "https://flagpedia.net/data/flags/h80/de.png",
      worldRank: 10,
      group: "E",
      groupPosition: 19,
      flaggedForEdit: false,
    },
    {
      id: "group-e-curacao",
      name: "Curaçao",
      teamNumber: 18,
      imageUrl: "https://flagpedia.net/data/flags/h80/cw.png",
      worldRank: 82,
      group: "E",
      groupPosition: 20,
      flaggedForEdit: false,
    },
  ],
  F: [
    {
      id: "group-f-japan",
      name: "Japan",
      teamNumber: 22,
      imageUrl: "https://flagpedia.net/data/flags/h80/jp.png",
      worldRank: 18,
      group: "F",
      groupPosition: 21,
      flaggedForEdit: false,
    },
    {
      id: "group-f-sweden",
      name: "Sweden",
      teamNumber: 23,
      imageUrl: "https://flagpedia.net/data/flags/h80/se.png",
      worldRank: 38,
      group: "F",
      groupPosition: 22,
      flaggedForEdit: false,
    },
    {
      id: "group-f-netherlands",
      name: "Netherlands",
      teamNumber: 21,
      imageUrl: "https://flagpedia.net/data/flags/h80/nl.png",
      worldRank: 7,
      group: "F",
      groupPosition: 23,
      flaggedForEdit: false,
    },
    {
      id: "group-f-tunisia",
      name: "Tunisia",
      teamNumber: 24,
      imageUrl: "https://flagpedia.net/data/flags/h80/tn.png",
      worldRank: 44,
      group: "F",
      groupPosition: 24,
      flaggedForEdit: false,
    },
  ],
  G: [
    {
      id: "group-g-egypt",
      name: "Egypt",
      teamNumber: 26,
      imageUrl: "https://flagpedia.net/data/flags/h80/eg.png",
      worldRank: 29,
      group: "G",
      groupPosition: 25,
      flaggedForEdit: false,
    },
    {
      id: "group-g-iran",
      name: "Iran",
      teamNumber: 27,
      imageUrl: "https://flagpedia.net/data/flags/h80/ir.png",
      worldRank: 21,
      group: "G",
      groupPosition: 26,
      flaggedForEdit: false,
    },
    {
      id: "group-g-belgium",
      name: "Belgium",
      teamNumber: 25,
      imageUrl: "https://flagpedia.net/data/flags/h80/be.png",
      worldRank: 9,
      group: "G",
      groupPosition: 27,
      flaggedForEdit: false,
    },
    {
      id: "group-g-new-zealand",
      name: "New Zealand",
      teamNumber: 28,
      imageUrl: "https://flagpedia.net/data/flags/h80/nz.png",
      worldRank: 85,
      group: "G",
      groupPosition: 28,
      flaggedForEdit: false,
    },
  ],
  H: [
    {
      id: "group-h-saudi-arabia",
      name: "Saudi Arabia",
      teamNumber: 31,
      imageUrl: "https://flagpedia.net/data/flags/h80/sa.png",
      worldRank: 61,
      group: "H",
      groupPosition: 29,
      flaggedForEdit: false,
    },
    {
      id: "group-h-uruguay",
      name: "Uruguay",
      teamNumber: 32,
      imageUrl: "https://flagpedia.net/data/flags/h80/uy.png",
      worldRank: 17,
      group: "H",
      groupPosition: 30,
      flaggedForEdit: false,
    },
    {
      id: "group-h-spain",
      name: "Spain",
      teamNumber: 29,
      imageUrl: "https://flagpedia.net/data/flags/h80/es.png",
      worldRank: 2,
      group: "H",
      groupPosition: 31,
      flaggedForEdit: false,
    },
    {
      id: "group-h-cape-verde",
      name: "Cape Verde",
      teamNumber: 30,
      imageUrl: "https://flagpedia.net/data/flags/h80/cv.png",
      worldRank: 69,
      group: "H",
      groupPosition: 32,
      flaggedForEdit: false,
    },
  ],
  I: [
    {
      id: "group-i-france",
      name: "France",
      teamNumber: 33,
      imageUrl: "https://flagpedia.net/data/flags/h80/fr.png",
      worldRank: 1,
      group: "I",
      groupPosition: 33,
      flaggedForEdit: false,
    },
    {
      id: "group-i-iraq",
      name: "Iraq",
      teamNumber: 35,
      imageUrl: "https://flagpedia.net/data/flags/h80/iq.png",
      worldRank: 57,
      group: "I",
      groupPosition: 34,
      flaggedForEdit: false,
    },
    {
      id: "group-i-norway",
      name: "Norway",
      teamNumber: 36,
      imageUrl: "https://flagpedia.net/data/flags/h80/no.png",
      worldRank: 31,
      group: "I",
      groupPosition: 35,
      flaggedForEdit: false,
    },
    {
      id: "group-i-senegal",
      name: "Senegal",
      teamNumber: 34,
      imageUrl: "https://flagpedia.net/data/flags/h80/sn.png",
      worldRank: 14,
      group: "I",
      groupPosition: 36,
      flaggedForEdit: false,
    },
  ],
  J: [
    {
      id: "group-j-algeria",
      name: "Algeria",
      teamNumber: 38,
      imageUrl: "https://flagpedia.net/data/flags/h80/dz.png",
      worldRank: 28,
      group: "J",
      groupPosition: 37,
      flaggedForEdit: false,
    },
    {
      id: "group-j-argentina",
      name: "Argentina",
      teamNumber: 37,
      imageUrl: "https://flagpedia.net/data/flags/h80/ar.png",
      worldRank: 3,
      group: "J",
      groupPosition: 38,
      flaggedForEdit: false,
    },
    {
      id: "group-j-austria",
      name: "Austria",
      teamNumber: 39,
      imageUrl: "https://flagpedia.net/data/flags/h80/at.png",
      worldRank: 24,
      group: "J",
      groupPosition: 39,
      flaggedForEdit: false,
    },
    {
      id: "group-j-jordan",
      name: "Jordan",
      teamNumber: 40,
      imageUrl: "https://flagpedia.net/data/flags/h80/jo.png",
      worldRank: 63,
      group: "J",
      groupPosition: 40,
      flaggedForEdit: false,
    },
  ],
  K: [
    {
      id: "group-k-colombia",
      name: "Colombia",
      teamNumber: 44,
      imageUrl: "https://flagpedia.net/data/flags/h80/co.png",
      worldRank: 13,
      group: "K",
      groupPosition: 41,
      flaggedForEdit: false,
    },
    {
      id: "group-k-portugal",
      name: "Portugal",
      teamNumber: 41,
      imageUrl: "https://flagpedia.net/data/flags/h80/pt.png",
      worldRank: 5,
      group: "K",
      groupPosition: 42,
      flaggedForEdit: false,
    },
    {
      id: "group-k-dr-congo",
      name: "DR Congo",
      teamNumber: 42,
      imageUrl: "https://flagpedia.net/data/flags/h80/cd.png",
      worldRank: 46,
      group: "K",
      groupPosition: 43,
      flaggedForEdit: false,
    },
    {
      id: "group-k-uzbekistan",
      name: "Uzbekistan",
      teamNumber: 43,
      imageUrl: "https://flagpedia.net/data/flags/h80/uz.png",
      worldRank: 50,
      group: "K",
      groupPosition: 44,
      flaggedForEdit: false,
    },
  ],
  L: [
    {
      id: "group-l-croatia",
      name: "Croatia",
      teamNumber: 46,
      imageUrl: "https://flagpedia.net/data/flags/h80/hr.png",
      worldRank: 11,
      group: "L",
      groupPosition: 45,
      flaggedForEdit: false,
    },
    {
      id: "group-l-england",
      name: "England",
      teamNumber: 45,
      imageUrl: "https://flagpedia.net/data/flags/h80/gb-eng.png",
      worldRank: 4,
      group: "L",
      groupPosition: 46,
      flaggedForEdit: false,
    },
    {
      id: "group-l-ghana",
      name: "Ghana",
      teamNumber: 47,
      imageUrl: "https://flagpedia.net/data/flags/h80/gh.png",
      worldRank: 74,
      group: "L",
      groupPosition: 47,
      flaggedForEdit: false,
    },
    {
      id: "group-l-panama",
      name: "Panama",
      teamNumber: 48,
      imageUrl: "https://flagpedia.net/data/flags/h80/pa.png",
      worldRank: 33,
      group: "L",
      groupPosition: 48,
      flaggedForEdit: false,
    },
  ],
};

export const testUpcomingGames = [
  {
    stage: "group",
    match_number: 1,
    match_datetime_utc: "2026-06-11T19:00:00.000+00:00",
    group_name: "A",
    game_status: "Final",
    team_1_goals: 2,
    team_2_goals: 0,
    winner: "team_1",
    team_1_name: "Mexico",
    team_1_flag: "https://flagpedia.net/data/flags/h80/mx.png",
    team_1_world_rank: 15,
    team_2_name: "South Africa",
    team_2_flag: "https://flagpedia.net/data/flags/h80/za.png",
    team_2_world_rank: 60,
  },
  {
    stage: "group",
    match_number: 2,
    match_datetime_utc: "2026-06-12T02:00:00.000+00:00",
    group_name: "A",
    game_status: "Final",
    team_1_goals: 2,
    team_2_goals: 1,
    winner: "team_1",
    team_1_name: "South Korea",
    team_1_flag: "https://flagpedia.net/data/flags/h80/kr.png",
    team_1_world_rank: 25,
    team_2_name: "Czech Republic",
    team_2_flag: "https://flagpedia.net/data/flags/h80/cz.png",
    team_2_world_rank: 41,
  },
  {
    stage: "group",
    match_number: 7,
    match_datetime_utc: "2026-06-12T19:00:00.000+00:00",
    group_name: "B",
    game_status: "InProgress",
    team_1_goals: 0,
    team_2_goals: 1,
    winner: "NotFinal",
    team_1_name: "Canada",
    team_1_flag: "https://flagpedia.net/data/flags/h80/ca.png",
    team_1_world_rank: 30,
    team_2_name: "Bosnia & Herz.",
    team_2_flag: "https://flagpedia.net/data/flags/h80/ba.png",
    team_2_world_rank: 65,
  },
  {
    stage: "group",
    match_number: 19,
    match_datetime_utc: "2026-06-13T01:00:00.000+00:00",
    group_name: "D",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "USA",
    team_1_flag: "https://flagpedia.net/data/flags/h80/us.png",
    team_1_world_rank: 16,
    team_2_name: "Paraguay",
    team_2_flag: "https://flagpedia.net/data/flags/h80/py.png",
    team_2_world_rank: 40,
  },
  {
    stage: "group",
    match_number: 8,
    match_datetime_utc: "2026-06-13T19:00:00.000+00:00",
    group_name: "B",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Qatar",
    team_1_flag: "https://flagpedia.net/data/flags/h80/qa.png",
    team_1_world_rank: 55,
    team_2_name: "Switzerland",
    team_2_flag: "https://flagpedia.net/data/flags/h80/ch.png",
    team_2_world_rank: 19,
  },
  {
    stage: "group",
    match_number: 13,
    match_datetime_utc: "2026-06-13T22:00:00.000+00:00",
    group_name: "C",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Brazil",
    team_1_flag: "https://flagpedia.net/data/flags/h80/br.png",
    team_1_world_rank: 6,
    team_2_name: "Morocco",
    team_2_flag: "https://flagpedia.net/data/flags/h80/ma.png",
    team_2_world_rank: 8,
  },
  {
    stage: "group",
    match_number: 14,
    match_datetime_utc: "2026-06-14T01:00:00.000+00:00",
    group_name: "C",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Haiti",
    team_1_flag: "https://flagpedia.net/data/flags/h80/ht.png",
    team_1_world_rank: 83,
    team_2_name: "Scotland",
    team_2_flag: "https://flagpedia.net/data/flags/h80/gb-sct.png",
    team_2_world_rank: 43,
  },
  {
    stage: "group",
    match_number: 20,
    match_datetime_utc: "2026-06-14T04:00:00.000+00:00",
    group_name: "D",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Australia",
    team_1_flag: "https://flagpedia.net/data/flags/h80/au.png",
    team_1_world_rank: 27,
    team_2_name: "Türkiye",
    team_2_flag: "https://flagpedia.net/data/flags/h80/tr.png",
    team_2_world_rank: 22,
  },
  {
    stage: "group",
    match_number: 25,
    match_datetime_utc: "2026-06-14T17:00:00.000+00:00",
    group_name: "E",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Germany",
    team_1_flag: "https://flagpedia.net/data/flags/h80/de.png",
    team_1_world_rank: 10,
    team_2_name: "Curaçao",
    team_2_flag: "https://flagpedia.net/data/flags/h80/cw.png",
    team_2_world_rank: 82,
  },
  {
    stage: "group",
    match_number: 31,
    match_datetime_utc: "2026-06-14T20:00:00.000+00:00",
    group_name: "F",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Netherlands",
    team_1_flag: "https://flagpedia.net/data/flags/h80/nl.png",
    team_1_world_rank: 7,
    team_2_name: "Japan",
    team_2_flag: "https://flagpedia.net/data/flags/h80/jp.png",
    team_2_world_rank: 18,
  },
  {
    stage: "group",
    match_number: 26,
    match_datetime_utc: "2026-06-14T23:00:00.000+00:00",
    group_name: "E",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Ivory Coast",
    team_1_flag: "https://flagpedia.net/data/flags/h80/ci.png",
    team_1_world_rank: 34,
    team_2_name: "Ecuador",
    team_2_flag: "https://flagpedia.net/data/flags/h80/ec.png",
    team_2_world_rank: 23,
  },
  {
    stage: "group",
    match_number: 32,
    match_datetime_utc: "2026-06-15T02:00:00.000+00:00",
    group_name: "F",
    game_status: "Scheduled",
    team_1_goals: 0,
    team_2_goals: 0,
    winner: "NotFinal",
    team_1_name: "Sweden",
    team_1_flag: "https://flagpedia.net/data/flags/h80/se.png",
    team_1_world_rank: 38,
    team_2_name: "Tunisia",
    team_2_flag: "https://flagpedia.net/data/flags/h80/tn.png",
    team_2_world_rank: 44,
  },
];

export const testGroupPicks = {
  A: [
    {
      group_standing_number: 1,
      pick_team_number: 1,
      points_earned: -1,
      group_name: "A",
      finish_position: 1,
      country_name: "Mexico",
      pick_flag: "https://flagpedia.net/data/flags/h80/mx.png",
      pick_world_rank: 15,
    },
    {
      group_standing_number: 2,
      pick_team_number: 3,
      points_earned: -1,
      group_name: "A",
      finish_position: 2,
      country_name: "South Korea",
      pick_flag: "https://flagpedia.net/data/flags/h80/kr.png",
      pick_world_rank: 25,
    },
    {
      group_standing_number: 3,
      pick_team_number: 2,
      points_earned: -1,
      group_name: "A",
      finish_position: 3,
      country_name: "South Africa",
      pick_flag: "https://flagpedia.net/data/flags/h80/za.png",
      pick_world_rank: 60,
    },
    {
      group_standing_number: 4,
      pick_team_number: 4,
      points_earned: -1,
      group_name: "A",
      finish_position: 4,
      country_name: "Czech Republic",
      pick_flag: "https://flagpedia.net/data/flags/h80/cz.png",
      pick_world_rank: 41,
    },
  ],
  B: [
    {
      group_standing_number: 5,
      pick_team_number: 6,
      points_earned: -1,
      group_name: "B",
      finish_position: 1,
      country_name: "Bosnia & Herz.",
      pick_flag: "https://flagpedia.net/data/flags/h80/ba.png",
      pick_world_rank: 65,
    },
    {
      group_standing_number: 6,
      pick_team_number: 8,
      points_earned: -1,
      group_name: "B",
      finish_position: 2,
      country_name: "Switzerland",
      pick_flag: "https://flagpedia.net/data/flags/h80/ch.png",
      pick_world_rank: 19,
    },
    {
      group_standing_number: 7,
      pick_team_number: 5,
      points_earned: -1,
      group_name: "B",
      finish_position: 3,
      country_name: "Canada",
      pick_flag: "https://flagpedia.net/data/flags/h80/ca.png",
      pick_world_rank: 30,
    },
    {
      group_standing_number: 8,
      pick_team_number: 7,
      points_earned: -1,
      group_name: "B",
      finish_position: 4,
      country_name: "Qatar",
      pick_flag: "https://flagpedia.net/data/flags/h80/qa.png",
      pick_world_rank: 55,
    },
  ],
  C: [
    {
      group_standing_number: 9,
      pick_team_number: 9,
      points_earned: -1,
      group_name: "C",
      finish_position: 1,
      country_name: "Brazil",
      pick_flag: "https://flagpedia.net/data/flags/h80/br.png",
      pick_world_rank: 6,
    },
    {
      group_standing_number: 10,
      pick_team_number: 10,
      points_earned: -1,
      group_name: "C",
      finish_position: 2,
      country_name: "Morocco",
      pick_flag: "https://flagpedia.net/data/flags/h80/ma.png",
      pick_world_rank: 8,
    },
    {
      group_standing_number: 11,
      pick_team_number: 12,
      points_earned: -1,
      group_name: "C",
      finish_position: 3,
      country_name: "Scotland",
      pick_flag: "https://flagpedia.net/data/flags/h80/gb-sct.png",
      pick_world_rank: 43,
    },
    {
      group_standing_number: 12,
      pick_team_number: 11,
      points_earned: -1,
      group_name: "C",
      finish_position: 4,
      country_name: "Haiti",
      pick_flag: "https://flagpedia.net/data/flags/h80/ht.png",
      pick_world_rank: 83,
    },
  ],
  D: [
    {
      group_standing_number: 13,
      pick_team_number: 13,
      points_earned: -1,
      group_name: "D",
      finish_position: 1,
      country_name: "USA",
      pick_flag: "https://flagpedia.net/data/flags/h80/us.png",
      pick_world_rank: 16,
    },
    {
      group_standing_number: 14,
      pick_team_number: 15,
      points_earned: -1,
      group_name: "D",
      finish_position: 2,
      country_name: "Australia",
      pick_flag: "https://flagpedia.net/data/flags/h80/au.png",
      pick_world_rank: 27,
    },
    {
      group_standing_number: 15,
      pick_team_number: 16,
      points_earned: -1,
      group_name: "D",
      finish_position: 3,
      country_name: "Türkiye",
      pick_flag: "https://flagpedia.net/data/flags/h80/tr.png",
      pick_world_rank: 22,
    },
    {
      group_standing_number: 16,
      pick_team_number: 14,
      points_earned: -1,
      group_name: "D",
      finish_position: 4,
      country_name: "Paraguay",
      pick_flag: "https://flagpedia.net/data/flags/h80/py.png",
      pick_world_rank: 40,
    },
  ],
  E: [
    {
      group_standing_number: 17,
      pick_team_number: 17,
      points_earned: -1,
      group_name: "E",
      finish_position: 1,
      country_name: "Germany",
      pick_flag: "https://flagpedia.net/data/flags/h80/de.png",
      pick_world_rank: 10,
    },
    {
      group_standing_number: 18,
      pick_team_number: 20,
      points_earned: -1,
      group_name: "E",
      finish_position: 2,
      country_name: "Ecuador",
      pick_flag: "https://flagpedia.net/data/flags/h80/ec.png",
      pick_world_rank: 23,
    },
    {
      group_standing_number: 19,
      pick_team_number: 19,
      points_earned: -1,
      group_name: "E",
      finish_position: 3,
      country_name: "Ivory Coast",
      pick_flag: "https://flagpedia.net/data/flags/h80/ci.png",
      pick_world_rank: 34,
    },
    {
      group_standing_number: 20,
      pick_team_number: 18,
      points_earned: -1,
      group_name: "E",
      finish_position: 4,
      country_name: "Curaçao",
      pick_flag: "https://flagpedia.net/data/flags/h80/cw.png",
      pick_world_rank: 82,
    },
  ],
  F: [
    {
      group_standing_number: 21,
      pick_team_number: 21,
      points_earned: -1,
      group_name: "F",
      finish_position: 1,
      country_name: "Netherlands",
      pick_flag: "https://flagpedia.net/data/flags/h80/nl.png",
      pick_world_rank: 7,
    },
    {
      group_standing_number: 22,
      pick_team_number: 22,
      points_earned: -1,
      group_name: "F",
      finish_position: 2,
      country_name: "Japan",
      pick_flag: "https://flagpedia.net/data/flags/h80/jp.png",
      pick_world_rank: 18,
    },
    {
      group_standing_number: 23,
      pick_team_number: 23,
      points_earned: -1,
      group_name: "F",
      finish_position: 3,
      country_name: "Sweden",
      pick_flag: "https://flagpedia.net/data/flags/h80/se.png",
      pick_world_rank: 38,
    },
    {
      group_standing_number: 24,
      pick_team_number: 24,
      points_earned: -1,
      group_name: "F",
      finish_position: 4,
      country_name: "Tunisia",
      pick_flag: "https://flagpedia.net/data/flags/h80/tn.png",
      pick_world_rank: 44,
    },
  ],
  G: [
    {
      group_standing_number: 25,
      pick_team_number: 25,
      points_earned: -1,
      group_name: "G",
      finish_position: 1,
      country_name: "Belgium",
      pick_flag: "https://flagpedia.net/data/flags/h80/be.png",
      pick_world_rank: 9,
    },
    {
      group_standing_number: 26,
      pick_team_number: 27,
      points_earned: -1,
      group_name: "G",
      finish_position: 2,
      country_name: "Iran",
      pick_flag: "https://flagpedia.net/data/flags/h80/ir.png",
      pick_world_rank: 21,
    },
    {
      group_standing_number: 27,
      pick_team_number: 26,
      points_earned: -1,
      group_name: "G",
      finish_position: 3,
      country_name: "Egypt",
      pick_flag: "https://flagpedia.net/data/flags/h80/eg.png",
      pick_world_rank: 29,
    },
    {
      group_standing_number: 28,
      pick_team_number: 28,
      points_earned: -1,
      group_name: "G",
      finish_position: 4,
      country_name: "New Zealand",
      pick_flag: "https://flagpedia.net/data/flags/h80/nz.png",
      pick_world_rank: 85,
    },
  ],
  H: [
    {
      group_standing_number: 29,
      pick_team_number: 29,
      points_earned: -1,
      group_name: "H",
      finish_position: 1,
      country_name: "Spain",
      pick_flag: "https://flagpedia.net/data/flags/h80/es.png",
      pick_world_rank: 2,
    },
    {
      group_standing_number: 30,
      pick_team_number: 32,
      points_earned: -1,
      group_name: "H",
      finish_position: 2,
      country_name: "Uruguay",
      pick_flag: "https://flagpedia.net/data/flags/h80/uy.png",
      pick_world_rank: 17,
    },
    {
      group_standing_number: 31,
      pick_team_number: 31,
      points_earned: -1,
      group_name: "H",
      finish_position: 3,
      country_name: "Saudi Arabia",
      pick_flag: "https://flagpedia.net/data/flags/h80/sa.png",
      pick_world_rank: 61,
    },
    {
      group_standing_number: 32,
      pick_team_number: 30,
      points_earned: -1,
      group_name: "H",
      finish_position: 4,
      country_name: "Cape Verde",
      pick_flag: "https://flagpedia.net/data/flags/h80/cv.png",
      pick_world_rank: 69,
    },
  ],
  I: [
    {
      group_standing_number: 33,
      pick_team_number: 33,
      points_earned: -1,
      group_name: "I",
      finish_position: 1,
      country_name: "France",
      pick_flag: "https://flagpedia.net/data/flags/h80/fr.png",
      pick_world_rank: 1,
    },
    {
      group_standing_number: 34,
      pick_team_number: 36,
      points_earned: -1,
      group_name: "I",
      finish_position: 2,
      country_name: "Norway",
      pick_flag: "https://flagpedia.net/data/flags/h80/no.png",
      pick_world_rank: 31,
    },
    {
      group_standing_number: 35,
      pick_team_number: 34,
      points_earned: -1,
      group_name: "I",
      finish_position: 3,
      country_name: "Senegal",
      pick_flag: "https://flagpedia.net/data/flags/h80/sn.png",
      pick_world_rank: 14,
    },
    {
      group_standing_number: 36,
      pick_team_number: 35,
      points_earned: -1,
      group_name: "I",
      finish_position: 4,
      country_name: "Iraq",
      pick_flag: "https://flagpedia.net/data/flags/h80/iq.png",
      pick_world_rank: 57,
    },
  ],
  J: [
    {
      group_standing_number: 37,
      pick_team_number: 37,
      points_earned: -1,
      group_name: "J",
      finish_position: 1,
      country_name: "Argentina",
      pick_flag: "https://flagpedia.net/data/flags/h80/ar.png",
      pick_world_rank: 3,
    },
    {
      group_standing_number: 38,
      pick_team_number: 39,
      points_earned: -1,
      group_name: "J",
      finish_position: 2,
      country_name: "Austria",
      pick_flag: "https://flagpedia.net/data/flags/h80/at.png",
      pick_world_rank: 24,
    },
    {
      group_standing_number: 39,
      pick_team_number: 38,
      points_earned: -1,
      group_name: "J",
      finish_position: 3,
      country_name: "Algeria",
      pick_flag: "https://flagpedia.net/data/flags/h80/dz.png",
      pick_world_rank: 28,
    },
    {
      group_standing_number: 40,
      pick_team_number: 40,
      points_earned: -1,
      group_name: "J",
      finish_position: 4,
      country_name: "Jordan",
      pick_flag: "https://flagpedia.net/data/flags/h80/jo.png",
      pick_world_rank: 63,
    },
  ],
  K: [
    {
      group_standing_number: 41,
      pick_team_number: 41,
      points_earned: -1,
      group_name: "K",
      finish_position: 1,
      country_name: "Portugal",
      pick_flag: "https://flagpedia.net/data/flags/h80/pt.png",
      pick_world_rank: 5,
    },
    {
      group_standing_number: 42,
      pick_team_number: 44,
      points_earned: -1,
      group_name: "K",
      finish_position: 2,
      country_name: "Colombia",
      pick_flag: "https://flagpedia.net/data/flags/h80/co.png",
      pick_world_rank: 13,
    },
    {
      group_standing_number: 43,
      pick_team_number: 43,
      points_earned: -1,
      group_name: "K",
      finish_position: 3,
      country_name: "Uzbekistan",
      pick_flag: "https://flagpedia.net/data/flags/h80/uz.png",
      pick_world_rank: 50,
    },
    {
      group_standing_number: 44,
      pick_team_number: 42,
      points_earned: -1,
      group_name: "K",
      finish_position: 4,
      country_name: "DR Congo",
      pick_flag: "https://flagpedia.net/data/flags/h80/cd.png",
      pick_world_rank: 46,
    },
  ],
  L: [
    {
      group_standing_number: 45,
      pick_team_number: 45,
      points_earned: -1,
      group_name: "L",
      finish_position: 1,
      country_name: "England",
      pick_flag: "https://flagpedia.net/data/flags/h80/gb-eng.png",
      pick_world_rank: 4,
    },
    {
      group_standing_number: 46,
      pick_team_number: 46,
      points_earned: -1,
      group_name: "L",
      finish_position: 2,
      country_name: "Croatia",
      pick_flag: "https://flagpedia.net/data/flags/h80/hr.png",
      pick_world_rank: 11,
    },
    {
      group_standing_number: 47,
      pick_team_number: 48,
      points_earned: -1,
      group_name: "L",
      finish_position: 3,
      country_name: "Panama",
      pick_flag: "https://flagpedia.net/data/flags/h80/pa.png",
      pick_world_rank: 33,
    },
    {
      group_standing_number: 48,
      pick_team_number: 47,
      points_earned: -1,
      group_name: "L",
      finish_position: 4,
      country_name: "Ghana",
      pick_flag: "https://flagpedia.net/data/flags/h80/gh.png",
      pick_world_rank: 74,
    },
  ],
};

export const testKoPicks = {
  groupPicks: [
    {
      team_number: 37,
      country_name: "Argentina",
      team_flag: "https://flagpedia.net/data/flags/h80/ar.png",
      team_world_rank: 3,
    },
    {
      team_number: 45,
      country_name: "England",
      team_flag: "https://flagpedia.net/data/flags/h80/gb-eng.png",
      team_world_rank: 4,
    },
    {
      team_number: 9,
      country_name: "Brazil",
      team_flag: "https://flagpedia.net/data/flags/h80/br.png",
      team_world_rank: 6,
    },
    {
      team_number: 21,
      country_name: "Netherlands",
      team_flag: "https://flagpedia.net/data/flags/h80/nl.png",
      team_world_rank: 7,
    },
    {
      team_number: 46,
      country_name: "Croatia",
      team_flag: "https://flagpedia.net/data/flags/h80/hr.png",
      team_world_rank: 11,
    },
    {
      team_number: 44,
      country_name: "Colombia",
      team_flag: "https://flagpedia.net/data/flags/h80/co.png",
      team_world_rank: 13,
    },
    {
      team_number: 32,
      country_name: "Uruguay",
      team_flag: "https://flagpedia.net/data/flags/h80/uy.png",
      team_world_rank: 17,
    },
    {
      team_number: 8,
      country_name: "Switzerland",
      team_flag: "https://flagpedia.net/data/flags/h80/ch.png",
      team_world_rank: 19,
    },
    {
      team_number: 27,
      country_name: "Iran",
      team_flag: "https://flagpedia.net/data/flags/h80/ir.png",
      team_world_rank: 21,
    },
    {
      team_number: 16,
      country_name: "Türkiye",
      team_flag: "https://flagpedia.net/data/flags/h80/tr.png",
      team_world_rank: 22,
    },
    {
      team_number: 3,
      country_name: "South Korea",
      team_flag: "https://flagpedia.net/data/flags/h80/kr.png",
      team_world_rank: 25,
    },
    {
      team_number: 38,
      country_name: "Algeria",
      team_flag: "https://flagpedia.net/data/flags/h80/dz.png",
      team_world_rank: 28,
    },
    {
      team_number: 26,
      country_name: "Egypt",
      team_flag: "https://flagpedia.net/data/flags/h80/eg.png",
      team_world_rank: 29,
    },
    {
      team_number: 36,
      country_name: "Norway",
      team_flag: "https://flagpedia.net/data/flags/h80/no.png",
      team_world_rank: 31,
    },
    {
      team_number: 19,
      country_name: "Ivory Coast",
      team_flag: "https://flagpedia.net/data/flags/h80/ci.png",
      team_world_rank: 34,
    },
    {
      team_number: 23,
      country_name: "Sweden",
      team_flag: "https://flagpedia.net/data/flags/h80/se.png",
      team_world_rank: 38,
    },
    {
      team_number: 14,
      country_name: "Paraguay",
      team_flag: "https://flagpedia.net/data/flags/h80/py.png",
      team_world_rank: 40,
    },
    {
      team_number: 4,
      country_name: "Czech Republic",
      team_flag: "https://flagpedia.net/data/flags/h80/cz.png",
      team_world_rank: 41,
    },
    {
      team_number: 12,
      country_name: "Scotland",
      team_flag: "https://flagpedia.net/data/flags/h80/gb-sct.png",
      team_world_rank: 43,
    },
    {
      team_number: 43,
      country_name: "Uzbekistan",
      team_flag: "https://flagpedia.net/data/flags/h80/uz.png",
      team_world_rank: 50,
    },
    {
      team_number: 35,
      country_name: "Iraq",
      team_flag: "https://flagpedia.net/data/flags/h80/iq.png",
      team_world_rank: 57,
    },
    {
      team_number: 31,
      country_name: "Saudi Arabia",
      team_flag: "https://flagpedia.net/data/flags/h80/sa.png",
      team_world_rank: 61,
    },
    {
      team_number: 6,
      country_name: "Bosnia & Herz.",
      team_flag: "https://flagpedia.net/data/flags/h80/ba.png",
      team_world_rank: 65,
    },
    {
      team_number: 18,
      country_name: "Curaçao",
      team_flag: "https://flagpedia.net/data/flags/h80/cw.png",
      team_world_rank: 82,
    },
    {
      team_number: 20,
      country_name: "Ecuador",
      team_flag: "https://flagpedia.net/data/flags/h80/ec.png",
      team_world_rank: 23,
    },
    {
      team_number: 11,
      country_name: "Haiti",
      team_flag: "https://flagpedia.net/data/flags/h80/ht.png",
      team_world_rank: 83,
    },
    {
      team_number: 1,
      country_name: "Mexico",
      team_flag: "https://flagpedia.net/data/flags/h80/mx.png",
      team_world_rank: 15,
    },
    {
      team_number: 5,
      country_name: "Canada",
      team_flag: "https://flagpedia.net/data/flags/h80/ca.png",
      team_world_rank: 30,
    },
    {
      team_number: 15,
      country_name: "Australia",
      team_flag: "https://flagpedia.net/data/flags/h80/au.png",
      team_world_rank: 27,
    },
    {
      team_number: 25,
      country_name: "Belgium",
      team_flag: "https://flagpedia.net/data/flags/h80/be.png",
      team_world_rank: 9,
    },
    {
      team_number: 22,
      country_name: "Japan",
      team_flag: "https://flagpedia.net/data/flags/h80/jp.png",
      team_world_rank: 18,
    },
    {
      team_number: 33,
      country_name: "France",
      team_flag: "https://flagpedia.net/data/flags/h80/fr.png",
      team_world_rank: 1,
    },
  ],
  round32: [],
  round16: [],
  quarterFinal: [],
  semiFinal: [],
  thirdPlace: [],
  final: [],
};

export const testThirdPicks = [
  {
    group_standing_number: 3,
    group_name: "A",
    ranking: -1,
    country_name: "South Africa",
    pick_team_number: 2,
    pick_flag: "https://flagpedia.net/data/flags/h80/za.png",
    pick_world_rank: 60,
  },
  {
    group_standing_number: 7,
    group_name: "B",
    ranking: -1,
    country_name: "Canada",
    pick_team_number: 5,
    pick_flag: "https://flagpedia.net/data/flags/h80/ca.png",
    pick_world_rank: 30,
  },
  {
    group_standing_number: 11,
    group_name: "C",
    ranking: -1,
    country_name: "Scotland",
    pick_team_number: 12,
    pick_flag: "https://flagpedia.net/data/flags/h80/gb-sct.png",
    pick_world_rank: 43,
  },
  {
    group_standing_number: 15,
    group_name: "D",
    ranking: -1,
    country_name: "Türkiye",
    pick_team_number: 16,
    pick_flag: "https://flagpedia.net/data/flags/h80/tr.png",
    pick_world_rank: 22,
  },
  {
    group_standing_number: 19,
    group_name: "E",
    ranking: -1,
    country_name: "Ivory Coast",
    pick_team_number: 19,
    pick_flag: "https://flagpedia.net/data/flags/h80/ci.png",
    pick_world_rank: 34,
  },
  {
    group_standing_number: 23,
    group_name: "F",
    ranking: -1,
    country_name: "Sweden",
    pick_team_number: 23,
    pick_flag: "https://flagpedia.net/data/flags/h80/se.png",
    pick_world_rank: 38,
  },
  {
    group_standing_number: 27,
    group_name: "G",
    ranking: -1,
    country_name: "Egypt",
    pick_team_number: 26,
    pick_flag: "https://flagpedia.net/data/flags/h80/eg.png",
    pick_world_rank: 29,
  },
  {
    group_standing_number: 31,
    group_name: "H",
    ranking: -1,
    country_name: "Saudi Arabia",
    pick_team_number: 31,
    pick_flag: "https://flagpedia.net/data/flags/h80/sa.png",
    pick_world_rank: 61,
  },
  {
    group_standing_number: 35,
    group_name: "I",
    ranking: -1,
    country_name: "Senegal",
    pick_team_number: 34,
    pick_flag: "https://flagpedia.net/data/flags/h80/sn.png",
    pick_world_rank: 14,
  },
  {
    group_standing_number: 39,
    group_name: "J",
    ranking: -1,
    country_name: "Algeria",
    pick_team_number: 38,
    pick_flag: "https://flagpedia.net/data/flags/h80/dz.png",
    pick_world_rank: 28,
  },
  {
    group_standing_number: 43,
    group_name: "K",
    ranking: -1,
    country_name: "Uzbekistan",
    pick_team_number: 43,
    pick_flag: "https://flagpedia.net/data/flags/h80/uz.png",
    pick_world_rank: 50,
  },
  {
    group_standing_number: 47,
    group_name: "L",
    ranking: -1,
    country_name: "Panama",
    pick_team_number: 48,
    pick_flag: "https://flagpedia.net/data/flags/h80/pa.png",
    pick_world_rank: 33,
  },
];

export const testGroups = [
  {
    group: "A",
    teams: [
      {
        id: "group-a-mexico",
        name: "Mexico",
        teamNumber: 1,
        imageUrl: "https://flagpedia.net/data/flags/h80/mx.png",
        worldRank: 15,
        group: "A",
        groupPosition: 1,
        flaggedForEdit: false,
      },
      {
        id: "group-a-south-africa",
        name: "South Africa",
        teamNumber: 2,
        imageUrl: "https://flagpedia.net/data/flags/h80/za.png",
        worldRank: 60,
        group: "A",
        groupPosition: 2,
        flaggedForEdit: false,
      },
      {
        id: "group-a-south-korea",
        name: "South Korea",
        teamNumber: 3,
        imageUrl: "https://flagpedia.net/data/flags/h80/kr.png",
        worldRank: 25,
        group: "A",
        groupPosition: 3,
        flaggedForEdit: false,
      },
      {
        id: "group-a-czech-republic",
        name: "Czech Republic",
        teamNumber: 4,
        imageUrl: "https://flagpedia.net/data/flags/h80/cz.png",
        worldRank: 41,
        group: "A",
        groupPosition: 4,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-a",
    cardActive: true,
    rankingStartFrom: 1,
  },
  {
    group: "B",
    teams: [
      {
        id: "group-b-switzerland",
        name: "Switzerland",
        teamNumber: 8,
        imageUrl: "https://flagpedia.net/data/flags/h80/ch.png",
        worldRank: 19,
        group: "B",
        groupPosition: 5,
        flaggedForEdit: false,
      },
      {
        id: "group-b-canada",
        name: "Canada",
        teamNumber: 5,
        imageUrl: "https://flagpedia.net/data/flags/h80/ca.png",
        worldRank: 30,
        group: "B",
        groupPosition: 6,
        flaggedForEdit: false,
      },
      {
        id: "group-b-qatar",
        name: "Qatar",
        teamNumber: 7,
        imageUrl: "https://flagpedia.net/data/flags/h80/qa.png",
        worldRank: 55,
        group: "B",
        groupPosition: 7,
        flaggedForEdit: false,
      },
      {
        id: "group-b-bosnia-herz",
        name: "Bosnia & Herz.",
        teamNumber: 6,
        imageUrl: "https://flagpedia.net/data/flags/h80/ba.png",
        worldRank: 65,
        group: "B",
        groupPosition: 8,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-b",
    cardActive: true,
    rankingStartFrom: 8,
  },
  {
    group: "C",
    teams: [
      {
        id: "group-c-scotland",
        name: "Scotland",
        teamNumber: 12,
        imageUrl: "https://flagpedia.net/data/flags/h80/gb-sct.png",
        worldRank: 43,
        group: "C",
        groupPosition: 9,
        flaggedForEdit: false,
      },
      {
        id: "group-c-brazil",
        name: "Brazil",
        teamNumber: 9,
        imageUrl: "https://flagpedia.net/data/flags/h80/br.png",
        worldRank: 6,
        group: "C",
        groupPosition: 10,
        flaggedForEdit: false,
      },
      {
        id: "group-c-haiti",
        name: "Haiti",
        teamNumber: 11,
        imageUrl: "https://flagpedia.net/data/flags/h80/ht.png",
        worldRank: 83,
        group: "C",
        groupPosition: 11,
        flaggedForEdit: false,
      },
      {
        id: "group-c-morocco",
        name: "Morocco",
        teamNumber: 10,
        imageUrl: "https://flagpedia.net/data/flags/h80/ma.png",
        worldRank: 8,
        group: "C",
        groupPosition: 12,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-c",
    cardActive: true,
    rankingStartFrom: 12,
  },
  {
    group: "D",
    teams: [
      {
        id: "group-d-australia",
        name: "Australia",
        teamNumber: 15,
        imageUrl: "https://flagpedia.net/data/flags/h80/au.png",
        worldRank: 27,
        group: "D",
        groupPosition: 13,
        flaggedForEdit: false,
      },
      {
        id: "group-d-turkiye",
        name: "Türkiye",
        teamNumber: 16,
        imageUrl: "https://flagpedia.net/data/flags/h80/tr.png",
        worldRank: 22,
        group: "D",
        groupPosition: 14,
        flaggedForEdit: false,
      },
      {
        id: "group-d-paraguay",
        name: "Paraguay",
        teamNumber: 14,
        imageUrl: "https://flagpedia.net/data/flags/h80/py.png",
        worldRank: 40,
        group: "D",
        groupPosition: 15,
        flaggedForEdit: false,
      },
      {
        id: "group-d-usa",
        name: "USA",
        teamNumber: 13,
        imageUrl: "https://flagpedia.net/data/flags/h80/us.png",
        worldRank: 16,
        group: "D",
        groupPosition: 16,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-d",
    cardActive: true,
    rankingStartFrom: 15,
  },
  {
    group: "E",
    teams: [
      {
        id: "group-e-ivory-coast",
        name: "Ivory Coast",
        teamNumber: 19,
        imageUrl: "https://flagpedia.net/data/flags/h80/ci.png",
        worldRank: 34,
        group: "E",
        groupPosition: 17,
        flaggedForEdit: false,
      },
      {
        id: "group-e-ecuador",
        name: "Ecuador",
        teamNumber: 20,
        imageUrl: "https://flagpedia.net/data/flags/h80/ec.png",
        worldRank: 23,
        group: "E",
        groupPosition: 18,
        flaggedForEdit: false,
      },
      {
        id: "group-e-germany",
        name: "Germany",
        teamNumber: 17,
        imageUrl: "https://flagpedia.net/data/flags/h80/de.png",
        worldRank: 10,
        group: "E",
        groupPosition: 19,
        flaggedForEdit: false,
      },
      {
        id: "group-e-curacao",
        name: "Curaçao",
        teamNumber: 18,
        imageUrl: "https://flagpedia.net/data/flags/h80/cw.png",
        worldRank: 82,
        group: "E",
        groupPosition: 20,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-e",
    cardActive: false,
    rankingStartFrom: 19,
  },
  {
    group: "F",
    teams: [
      {
        id: "group-f-japan",
        name: "Japan",
        teamNumber: 22,
        imageUrl: "https://flagpedia.net/data/flags/h80/jp.png",
        worldRank: 18,
        group: "F",
        groupPosition: 21,
        flaggedForEdit: false,
      },
      {
        id: "group-f-sweden",
        name: "Sweden",
        teamNumber: 23,
        imageUrl: "https://flagpedia.net/data/flags/h80/se.png",
        worldRank: 38,
        group: "F",
        groupPosition: 22,
        flaggedForEdit: false,
      },
      {
        id: "group-f-netherlands",
        name: "Netherlands",
        teamNumber: 21,
        imageUrl: "https://flagpedia.net/data/flags/h80/nl.png",
        worldRank: 7,
        group: "F",
        groupPosition: 23,
        flaggedForEdit: false,
      },
      {
        id: "group-f-tunisia",
        name: "Tunisia",
        teamNumber: 24,
        imageUrl: "https://flagpedia.net/data/flags/h80/tn.png",
        worldRank: 44,
        group: "F",
        groupPosition: 24,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-f",
    cardActive: true,
    rankingStartFrom: 22,
  },
  {
    group: "G",
    teams: [
      {
        id: "group-g-egypt",
        name: "Egypt",
        teamNumber: 26,
        imageUrl: "https://flagpedia.net/data/flags/h80/eg.png",
        worldRank: 29,
        group: "G",
        groupPosition: 25,
        flaggedForEdit: false,
      },
      {
        id: "group-g-iran",
        name: "Iran",
        teamNumber: 27,
        imageUrl: "https://flagpedia.net/data/flags/h80/ir.png",
        worldRank: 21,
        group: "G",
        groupPosition: 26,
        flaggedForEdit: false,
      },
      {
        id: "group-g-belgium",
        name: "Belgium",
        teamNumber: 25,
        imageUrl: "https://flagpedia.net/data/flags/h80/be.png",
        worldRank: 9,
        group: "G",
        groupPosition: 27,
        flaggedForEdit: false,
      },
      {
        id: "group-g-new-zealand",
        name: "New Zealand",
        teamNumber: 28,
        imageUrl: "https://flagpedia.net/data/flags/h80/nz.png",
        worldRank: 85,
        group: "G",
        groupPosition: 28,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-g",
    cardActive: true,
    rankingStartFrom: 26,
  },
  {
    group: "H",
    teams: [
      {
        id: "group-h-saudi-arabia",
        name: "Saudi Arabia",
        teamNumber: 31,
        imageUrl: "https://flagpedia.net/data/flags/h80/sa.png",
        worldRank: 61,
        group: "H",
        groupPosition: 29,
        flaggedForEdit: false,
      },
      {
        id: "group-h-uruguay",
        name: "Uruguay",
        teamNumber: 32,
        imageUrl: "https://flagpedia.net/data/flags/h80/uy.png",
        worldRank: 17,
        group: "H",
        groupPosition: 30,
        flaggedForEdit: false,
      },
      {
        id: "group-h-spain",
        name: "Spain",
        teamNumber: 29,
        imageUrl: "https://flagpedia.net/data/flags/h80/es.png",
        worldRank: 2,
        group: "H",
        groupPosition: 31,
        flaggedForEdit: false,
      },
      {
        id: "group-h-cape-verde",
        name: "Cape Verde",
        teamNumber: 30,
        imageUrl: "https://flagpedia.net/data/flags/h80/cv.png",
        worldRank: 69,
        group: "H",
        groupPosition: 32,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-h",
    cardActive: true,
    rankingStartFrom: 31,
  },
  {
    group: "I",
    teams: [
      {
        id: "group-i-france",
        name: "France",
        teamNumber: 33,
        imageUrl: "https://flagpedia.net/data/flags/h80/fr.png",
        worldRank: 1,
        group: "I",
        groupPosition: 33,
        flaggedForEdit: false,
      },
      {
        id: "group-i-iraq",
        name: "Iraq",
        teamNumber: 35,
        imageUrl: "https://flagpedia.net/data/flags/h80/iq.png",
        worldRank: 57,
        group: "I",
        groupPosition: 34,
        flaggedForEdit: false,
      },
      {
        id: "group-i-norway",
        name: "Norway",
        teamNumber: 36,
        imageUrl: "https://flagpedia.net/data/flags/h80/no.png",
        worldRank: 31,
        group: "I",
        groupPosition: 35,
        flaggedForEdit: false,
      },
      {
        id: "group-i-senegal",
        name: "Senegal",
        teamNumber: 34,
        imageUrl: "https://flagpedia.net/data/flags/h80/sn.png",
        worldRank: 14,
        group: "I",
        groupPosition: 36,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-i",
    cardActive: false,
    rankingStartFrom: 33,
  },
  {
    group: "J",
    teams: [
      {
        id: "group-j-algeria",
        name: "Algeria",
        teamNumber: 38,
        imageUrl: "https://flagpedia.net/data/flags/h80/dz.png",
        worldRank: 28,
        group: "J",
        groupPosition: 37,
        flaggedForEdit: false,
      },
      {
        id: "group-j-argentina",
        name: "Argentina",
        teamNumber: 37,
        imageUrl: "https://flagpedia.net/data/flags/h80/ar.png",
        worldRank: 3,
        group: "J",
        groupPosition: 38,
        flaggedForEdit: false,
      },
      {
        id: "group-j-austria",
        name: "Austria",
        teamNumber: 39,
        imageUrl: "https://flagpedia.net/data/flags/h80/at.png",
        worldRank: 24,
        group: "J",
        groupPosition: 39,
        flaggedForEdit: false,
      },
      {
        id: "group-j-jordan",
        name: "Jordan",
        teamNumber: 40,
        imageUrl: "https://flagpedia.net/data/flags/h80/jo.png",
        worldRank: 63,
        group: "J",
        groupPosition: 40,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-j",
    cardActive: false,
    rankingStartFrom: 38,
  },
  {
    group: "K",
    teams: [
      {
        id: "group-k-colombia",
        name: "Colombia",
        teamNumber: 44,
        imageUrl: "https://flagpedia.net/data/flags/h80/co.png",
        worldRank: 13,
        group: "K",
        groupPosition: 41,
        flaggedForEdit: false,
      },
      {
        id: "group-k-portugal",
        name: "Portugal",
        teamNumber: 41,
        imageUrl: "https://flagpedia.net/data/flags/h80/pt.png",
        worldRank: 5,
        group: "K",
        groupPosition: 42,
        flaggedForEdit: false,
      },
      {
        id: "group-k-dr-congo",
        name: "DR Congo",
        teamNumber: 42,
        imageUrl: "https://flagpedia.net/data/flags/h80/cd.png",
        worldRank: 46,
        group: "K",
        groupPosition: 43,
        flaggedForEdit: false,
      },
      {
        id: "group-k-uzbekistan",
        name: "Uzbekistan",
        teamNumber: 43,
        imageUrl: "https://flagpedia.net/data/flags/h80/uz.png",
        worldRank: 50,
        group: "K",
        groupPosition: 44,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-k",
    cardActive: false,
    rankingStartFrom: 44,
  },
  {
    group: "L",
    teams: [
      {
        id: "group-l-croatia",
        name: "Croatia",
        teamNumber: 46,
        imageUrl: "https://flagpedia.net/data/flags/h80/hr.png",
        worldRank: 11,
        group: "L",
        groupPosition: 45,
        flaggedForEdit: false,
      },
      {
        id: "group-l-england",
        name: "England",
        teamNumber: 45,
        imageUrl: "https://flagpedia.net/data/flags/h80/gb-eng.png",
        worldRank: 4,
        group: "L",
        groupPosition: 46,
        flaggedForEdit: false,
      },
      {
        id: "group-l-ghana",
        name: "Ghana",
        teamNumber: 47,
        imageUrl: "https://flagpedia.net/data/flags/h80/gh.png",
        worldRank: 74,
        group: "L",
        groupPosition: 47,
        flaggedForEdit: false,
      },
      {
        id: "group-l-panama",
        name: "Panama",
        teamNumber: 48,
        imageUrl: "https://flagpedia.net/data/flags/h80/pa.png",
        worldRank: 33,
        group: "L",
        groupPosition: 48,
        flaggedForEdit: false,
      },
    ],
    groupId: "group-picks-l",
    cardActive: false,
    rankingStartFrom: 46,
  },
];

export const testAllTeams = [
  {
    id: "group-a-mexico",
    name: "Mexico",
    teamNumber: 1,
    imageUrl: "https://flagpedia.net/data/flags/h80/mx.png",
    worldRank: 15,
    group: "A",
    groupPosition: 1,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-a-south-africa",
    name: "South Africa",
    teamNumber: 2,
    imageUrl: "https://flagpedia.net/data/flags/h80/za.png",
    worldRank: 60,
    group: "A",
    groupPosition: 2,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-a-south-korea",
    name: "South Korea",
    teamNumber: 3,
    imageUrl: "https://flagpedia.net/data/flags/h80/kr.png",
    worldRank: 25,
    group: "A",
    groupPosition: 3,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-a-czech-republic",
    name: "Czech Republic",
    teamNumber: 4,
    imageUrl: "https://flagpedia.net/data/flags/h80/cz.png",
    worldRank: 41,
    group: "A",
    groupPosition: 4,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-b-switzerland",
    name: "Switzerland",
    teamNumber: 8,
    imageUrl: "https://flagpedia.net/data/flags/h80/ch.png",
    worldRank: 19,
    group: "B",
    groupPosition: 5,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-b-qatar",
    name: "Qatar",
    teamNumber: 7,
    imageUrl: "https://flagpedia.net/data/flags/h80/qa.png",
    worldRank: 55,
    group: "B",
    groupPosition: 7,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-b-canada",
    name: "Canada",
    teamNumber: 5,
    imageUrl: "https://flagpedia.net/data/flags/h80/ca.png",
    worldRank: 30,
    group: "B",
    groupPosition: 6,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-b-bosnia-herz",
    name: "Bosnia & Herz.",
    teamNumber: 6,
    imageUrl: "https://flagpedia.net/data/flags/h80/ba.png",
    worldRank: 65,
    group: "B",
    groupPosition: 8,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-c-scotland",
    name: "Scotland",
    teamNumber: 12,
    imageUrl: "https://flagpedia.net/data/flags/h80/gb-sct.png",
    worldRank: 43,
    group: "C",
    groupPosition: 9,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-c-brazil",
    name: "Brazil",
    teamNumber: 9,
    imageUrl: "https://flagpedia.net/data/flags/h80/br.png",
    worldRank: 6,
    group: "C",
    groupPosition: 10,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-c-haiti",
    name: "Haiti",
    teamNumber: 11,
    imageUrl: "https://flagpedia.net/data/flags/h80/ht.png",
    worldRank: 83,
    group: "C",
    groupPosition: 11,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-c-morocco",
    name: "Morocco",
    teamNumber: 10,
    imageUrl: "https://flagpedia.net/data/flags/h80/ma.png",
    worldRank: 8,
    group: "C",
    groupPosition: 12,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-d-australia",
    name: "Australia",
    teamNumber: 15,
    imageUrl: "https://flagpedia.net/data/flags/h80/au.png",
    worldRank: 27,
    group: "D",
    groupPosition: 13,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-d-turkiye",
    name: "Türkiye",
    teamNumber: 16,
    imageUrl: "https://flagpedia.net/data/flags/h80/tr.png",
    worldRank: 22,
    group: "D",
    groupPosition: 14,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-d-paraguay",
    name: "Paraguay",
    teamNumber: 14,
    imageUrl: "https://flagpedia.net/data/flags/h80/py.png",
    worldRank: 40,
    group: "D",
    groupPosition: 15,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-d-usa",
    name: "USA",
    teamNumber: 13,
    imageUrl: "https://flagpedia.net/data/flags/h80/us.png",
    worldRank: 16,
    group: "D",
    groupPosition: 16,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-e-ivory-coast",
    name: "Ivory Coast",
    teamNumber: 19,
    imageUrl: "https://flagpedia.net/data/flags/h80/ci.png",
    worldRank: 34,
    group: "E",
    groupPosition: 17,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-e-ecuador",
    name: "Ecuador",
    teamNumber: 20,
    imageUrl: "https://flagpedia.net/data/flags/h80/ec.png",
    worldRank: 23,
    group: "E",
    groupPosition: 18,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-e-germany",
    name: "Germany",
    teamNumber: 17,
    imageUrl: "https://flagpedia.net/data/flags/h80/de.png",
    worldRank: 10,
    group: "E",
    groupPosition: 19,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-e-curacao",
    name: "Curaçao",
    teamNumber: 18,
    imageUrl: "https://flagpedia.net/data/flags/h80/cw.png",
    worldRank: 82,
    group: "E",
    groupPosition: 20,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-f-japan",
    name: "Japan",
    teamNumber: 22,
    imageUrl: "https://flagpedia.net/data/flags/h80/jp.png",
    worldRank: 18,
    group: "F",
    groupPosition: 21,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-f-sweden",
    name: "Sweden",
    teamNumber: 23,
    imageUrl: "https://flagpedia.net/data/flags/h80/se.png",
    worldRank: 38,
    group: "F",
    groupPosition: 22,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-f-netherlands",
    name: "Netherlands",
    teamNumber: 21,
    imageUrl: "https://flagpedia.net/data/flags/h80/nl.png",
    worldRank: 7,
    group: "F",
    groupPosition: 23,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-f-tunisia",
    name: "Tunisia",
    teamNumber: 24,
    imageUrl: "https://flagpedia.net/data/flags/h80/tn.png",
    worldRank: 44,
    group: "F",
    groupPosition: 24,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-g-egypt",
    name: "Egypt",
    teamNumber: 26,
    imageUrl: "https://flagpedia.net/data/flags/h80/eg.png",
    worldRank: 29,
    group: "G",
    groupPosition: 25,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-g-iran",
    name: "Iran",
    teamNumber: 27,
    imageUrl: "https://flagpedia.net/data/flags/h80/ir.png",
    worldRank: 21,
    group: "G",
    groupPosition: 26,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-g-belgium",
    name: "Belgium",
    teamNumber: 25,
    imageUrl: "https://flagpedia.net/data/flags/h80/be.png",
    worldRank: 9,
    group: "G",
    groupPosition: 27,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-g-new-zealand",
    name: "New Zealand",
    teamNumber: 28,
    imageUrl: "https://flagpedia.net/data/flags/h80/nz.png",
    worldRank: 85,
    group: "G",
    groupPosition: 28,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-h-saudi-arabia",
    name: "Saudi Arabia",
    teamNumber: 31,
    imageUrl: "https://flagpedia.net/data/flags/h80/sa.png",
    worldRank: 61,
    group: "H",
    groupPosition: 29,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-h-uruguay",
    name: "Uruguay",
    teamNumber: 32,
    imageUrl: "https://flagpedia.net/data/flags/h80/uy.png",
    worldRank: 17,
    group: "H",
    groupPosition: 30,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-h-spain",
    name: "Spain",
    teamNumber: 29,
    imageUrl: "https://flagpedia.net/data/flags/h80/es.png",
    worldRank: 2,
    group: "H",
    groupPosition: 31,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-h-cape-verde",
    name: "Cape Verde",
    teamNumber: 30,
    imageUrl: "https://flagpedia.net/data/flags/h80/cv.png",
    worldRank: 69,
    group: "H",
    groupPosition: 32,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-i-france",
    name: "France",
    teamNumber: 33,
    imageUrl: "https://flagpedia.net/data/flags/h80/fr.png",
    worldRank: 1,
    group: "I",
    groupPosition: 33,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-i-iraq",
    name: "Iraq",
    teamNumber: 35,
    imageUrl: "https://flagpedia.net/data/flags/h80/iq.png",
    worldRank: 57,
    group: "I",
    groupPosition: 34,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-i-norway",
    name: "Norway",
    teamNumber: 36,
    imageUrl: "https://flagpedia.net/data/flags/h80/no.png",
    worldRank: 31,
    group: "I",
    groupPosition: 35,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-i-senegal",
    name: "Senegal",
    teamNumber: 34,
    imageUrl: "https://flagpedia.net/data/flags/h80/sn.png",
    worldRank: 14,
    group: "I",
    groupPosition: 36,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-j-algeria",
    name: "Algeria",
    teamNumber: 38,
    imageUrl: "https://flagpedia.net/data/flags/h80/dz.png",
    worldRank: 28,
    group: "J",
    groupPosition: 37,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-j-argentina",
    name: "Argentina",
    teamNumber: 37,
    imageUrl: "https://flagpedia.net/data/flags/h80/ar.png",
    worldRank: 3,
    group: "J",
    groupPosition: 38,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-j-austria",
    name: "Austria",
    teamNumber: 39,
    imageUrl: "https://flagpedia.net/data/flags/h80/at.png",
    worldRank: 24,
    group: "J",
    groupPosition: 39,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-j-jordan",
    name: "Jordan",
    teamNumber: 40,
    imageUrl: "https://flagpedia.net/data/flags/h80/jo.png",
    worldRank: 63,
    group: "J",
    groupPosition: 40,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-k-colombia",
    name: "Colombia",
    teamNumber: 44,
    imageUrl: "https://flagpedia.net/data/flags/h80/co.png",
    worldRank: 13,
    group: "K",
    groupPosition: 41,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-k-portugal",
    name: "Portugal",
    teamNumber: 41,
    imageUrl: "https://flagpedia.net/data/flags/h80/pt.png",
    worldRank: 5,
    group: "K",
    groupPosition: 42,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-k-dr-congo",
    name: "DR Congo",
    teamNumber: 42,
    imageUrl: "https://flagpedia.net/data/flags/h80/cd.png",
    worldRank: 46,
    group: "K",
    groupPosition: 43,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-k-uzbekistan",
    name: "Uzbekistan",
    teamNumber: 43,
    imageUrl: "https://flagpedia.net/data/flags/h80/uz.png",
    worldRank: 50,
    group: "K",
    groupPosition: 44,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-l-croatia",
    name: "Croatia",
    teamNumber: 46,
    imageUrl: "https://flagpedia.net/data/flags/h80/hr.png",
    worldRank: 11,
    group: "L",
    groupPosition: 45,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-l-england",
    name: "England",
    teamNumber: 45,
    imageUrl: "https://flagpedia.net/data/flags/h80/gb-eng.png",
    worldRank: 4,
    group: "L",
    groupPosition: 46,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-l-ghana",
    name: "Ghana",
    teamNumber: 47,
    imageUrl: "https://flagpedia.net/data/flags/h80/gh.png",
    worldRank: 74,
    group: "L",
    groupPosition: 47,
    flaggedForEdit: false,
    cardActive: true,
  },
  {
    id: "group-l-panama",
    name: "Panama",
    teamNumber: 48,
    imageUrl: "https://flagpedia.net/data/flags/h80/pa.png",
    worldRank: 33,
    group: "L",
    groupPosition: 48,
    flaggedForEdit: false,
    cardActive: true,
  },
];

export const testStatus = {
  contest_status: {
    play_starts_at: "2026-06-11T20:30:00.000Z",
    current_stage: "group",
  },
  user_status: {
    entry_page: "group",
    focus: "group-a",
    completed_groups: {
      A: false,
      B: true,
      C: false,
      D: false,
      E: false,
      F: false,
      G: false,
      H: false,
      I: false,
      J: false,
      K: false,
      L: false,
    },
    all_groups_picks_complete: false,
    third_place_picks_complete: false,
    completed_rounds: {
      round32: false,
      round16: false,
      quarterFinal: false,
      semiFinal: false,
      thirdPlace: false,
      final: false,
    },
    group_stage_complete: false,
    all_picks_complete: false,
    tiebreaker_answer: -1,
    picks_submitted: false,
  },
  games_window: [
    {
      stage: "group",
      match_number: 2,
      match_datetime_utc: "2026-06-12T02:00:00.000+00:00",
      group_name: "A",
      game_status: "Final",
      team_1_goals: 2,
      team_2_goals: 1,
      winner: "team_1",
      team_1_name: "South Korea",
      team_1_flag: "https://flagpedia.net/data/flags/h80/kr.png",
      team_1_world_rank: 25,
      team_2_name: "Czech Republic",
      team_2_flag: "https://flagpedia.net/data/flags/h80/cz.png",
      team_2_world_rank: 41,
    },
    {
      stage: "group",
      match_number: 7,
      match_datetime_utc: "2026-06-12T19:00:00.000+00:00",
      group_name: "B",
      game_status: "Final",
      team_1_goals: 1,
      team_2_goals: 1,
      winner: "Draw",
      team_1_name: "Canada",
      team_1_flag: "https://flagpedia.net/data/flags/h80/ca.png",
      team_1_world_rank: 30,
      team_2_name: "Bosnia & Herz.",
      team_2_flag: "https://flagpedia.net/data/flags/h80/ba.png",
      team_2_world_rank: 65,
    },
    {
      stage: "group",
      match_number: 19,
      match_datetime_utc: "2026-06-13T01:00:00.000+00:00",
      group_name: "D",
      game_status: "InProgress",
      team_1_goals: 3,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "USA",
      team_1_flag: "https://flagpedia.net/data/flags/h80/us.png",
      team_1_world_rank: 16,
      team_2_name: "Paraguay",
      team_2_flag: "https://flagpedia.net/data/flags/h80/py.png",
      team_2_world_rank: 40,
    },
    {
      stage: "group",
      match_number: 8,
      match_datetime_utc: "2026-06-13T19:00:00.000+00:00",
      group_name: "B",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Qatar",
      team_1_flag: "https://flagpedia.net/data/flags/h80/qa.png",
      team_1_world_rank: 55,
      team_2_name: "Switzerland",
      team_2_flag: "https://flagpedia.net/data/flags/h80/ch.png",
      team_2_world_rank: 19,
    },
    {
      stage: "group",
      match_number: 13,
      match_datetime_utc: "2026-06-13T22:00:00.000+00:00",
      group_name: "C",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Brazil",
      team_1_flag: "https://flagpedia.net/data/flags/h80/br.png",
      team_1_world_rank: 6,
      team_2_name: "Morocco",
      team_2_flag: "https://flagpedia.net/data/flags/h80/ma.png",
      team_2_world_rank: 8,
    },
    {
      stage: "group",
      match_number: 14,
      match_datetime_utc: "2026-06-14T01:00:00.000+00:00",
      group_name: "C",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Haiti",
      team_1_flag: "https://flagpedia.net/data/flags/h80/ht.png",
      team_1_world_rank: 83,
      team_2_name: "Scotland",
      team_2_flag: "https://flagpedia.net/data/flags/h80/gb-sct.png",
      team_2_world_rank: 43,
    },
    {
      stage: "group",
      match_number: 20,
      match_datetime_utc: "2026-06-14T04:00:00.000+00:00",
      group_name: "D",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Australia",
      team_1_flag: "https://flagpedia.net/data/flags/h80/au.png",
      team_1_world_rank: 27,
      team_2_name: "Türkiye",
      team_2_flag: "https://flagpedia.net/data/flags/h80/tr.png",
      team_2_world_rank: 22,
    },
    {
      stage: "group",
      match_number: 25,
      match_datetime_utc: "2026-06-14T17:00:00.000+00:00",
      group_name: "E",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Germany",
      team_1_flag: "https://flagpedia.net/data/flags/h80/de.png",
      team_1_world_rank: 10,
      team_2_name: "Curaçao",
      team_2_flag: "https://flagpedia.net/data/flags/h80/cw.png",
      team_2_world_rank: 82,
    },
    {
      stage: "group",
      match_number: 31,
      match_datetime_utc: "2026-06-14T20:00:00.000+00:00",
      group_name: "F",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Netherlands",
      team_1_flag: "https://flagpedia.net/data/flags/h80/nl.png",
      team_1_world_rank: 7,
      team_2_name: "Japan",
      team_2_flag: "https://flagpedia.net/data/flags/h80/jp.png",
      team_2_world_rank: 18,
    },
    {
      stage: "group",
      match_number: 26,
      match_datetime_utc: "2026-06-14T23:00:00.000+00:00",
      group_name: "E",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Ivory Coast",
      team_1_flag: "https://flagpedia.net/data/flags/h80/ci.png",
      team_1_world_rank: 34,
      team_2_name: "Ecuador",
      team_2_flag: "https://flagpedia.net/data/flags/h80/ec.png",
      team_2_world_rank: 23,
    },
    {
      stage: "group",
      match_number: 32,
      match_datetime_utc: "2026-06-15T02:00:00.000+00:00",
      group_name: "F",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Sweden",
      team_1_flag: "https://flagpedia.net/data/flags/h80/se.png",
      team_1_world_rank: 38,
      team_2_name: "Tunisia",
      team_2_flag: "https://flagpedia.net/data/flags/h80/tn.png",
      team_2_world_rank: 44,
    },
    {
      stage: "group",
      match_number: 43,
      match_datetime_utc: "2026-06-15T16:00:00.000+00:00",
      group_name: "H",
      game_status: "Scheduled",
      team_1_goals: 0,
      team_2_goals: 0,
      winner: "NotFinal",
      team_1_name: "Spain",
      team_1_flag: "https://flagpedia.net/data/flags/h80/es.png",
      team_1_world_rank: 2,
      team_2_name: "Cape Verde",
      team_2_flag: "https://flagpedia.net/data/flags/h80/cv.png",
      team_2_world_rank: 69,
    },
  ],
};
